import React from 'react';
import { testimonials } from '../data/mock';
import { Star } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-fuchsia-500 font-semibold text-sm uppercase tracking-wide">
            Real Stories
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mt-2 mb-4">
            Families <span className="text-nursebloc-gradient">We've Helped</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from families who found peace of mind with NurseBloc.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-violet-50 to-fuchsia-50 rounded-3xl p-8 border border-violet-100"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-amber-400" fill="currentColor" />
                ))}
              </div>
              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>
              <div>
                <p className="font-semibold text-slate-800">{testimonial.author}</p>
                <p className="text-sm text-violet-600">{testimonial.relation}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
